import React, { useState } from "react";
import "./Product.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons/faStar";
import { faIndianRupeeSign } from "@fortawesome/free-solid-svg-icons/faIndianRupeeSign";
import { useParams } from 'react-router-dom';
import { ProductsData } from "./ProductData";

const ProductDetail = () => {
    const { id } = useParams();
    const product = ProductsData.find(p => p.id === parseInt(id));

    const [activeImage, setActiveImage] = useState(product?.img); // set default image

    if (!product) {
        return <h2>Product not found</h2>;
    }

    const handleImageClick = (imgSrc) => {
        setActiveImage(imgSrc);
    };

    return (
        <div className='product-details'>
            <div className='product-details-left'>
                <div className='productdetails-img-list'>
                    {[product.img1, product.img2, product.img3, product.img4].map((imgSrc, index) => (
                        <img
                            key={index}
                            src={imgSrc}
                            alt={`product-${index}`}
                            onClick={() => handleImageClick(imgSrc)}
                            className={`thumbnail ${activeImage === imgSrc ? 'active-thumbnail' : ''}`}
                        />
                    ))}
                </div>
                <div className='productdetails-img'>
                    <img className='productdetails-main-img' src={activeImage} alt='Main Product' />
                </div>
            </div>
            <div className='product-details-right'>
                <h1>{product.name}</h1>
                <h3>Brand: STEMCity</h3>
                <div className='productdetails-right-star'>
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                </div>
                <div className='productdetails-right-prices'>
                    <div className='productdetails-right-price-old'>
                        <FontAwesomeIcon icon={faIndianRupeeSign} /> {product.price2}
                    </div>
                    <div className='productdetails-right-price-new'>
                        <FontAwesomeIcon icon={faIndianRupeeSign} /> {product.price}
                    </div>
                </div>
                <div className='productdetails-right-description'>
                    {product.description}
                </div>
            </div>
        </div>
    );
};

export default ProductDetail;
